import { ValueObject } from '@nx-smartmonkey/shared/domain';

interface AnalyticsSummaryProps {
  start_date: Date;
  end_date: Date;
  completed_stops: number;
  incomplete_stops?: number;
  canceled_stops: number;
  total_km: number;
  total_emissions: number;
}

export class AnalyticsSummary extends ValueObject<AnalyticsSummaryProps> {
  private constructor(props: AnalyticsSummaryProps) {
    super(props);
  }

  static create(props: AnalyticsSummaryProps): AnalyticsSummary {
    return new AnalyticsSummary(props);
  }

  get start_date(): Date {
    return this.props.start_date;
  }

  get end_date(): Date {
    return this.props.end_date;
  }

  get completed_stops(): number {
    return this.props.completed_stops;
  }

  get incomplete_stops(): number | undefined {
    return this.props.incomplete_stops;
  }

  get canceled_stops(): number {
    return this.props.canceled_stops;
  }

  get total_km(): number {
    return this.props.total_km;
  }

  get total_emissions(): number {
    return this.props.total_emissions;
  }
}
